import { FormControl, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import useSWRMutation from "swr/mutation";
import { useSWRConfig } from "swr";

import {
  getSettingState,
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../../redux/features/settingSlice";
import { fetcherPatch } from "../../../../services/fetcher";
import CustomButton from "../../CustomButton";
import CustomInput from "../../CustomInput";

const EditProfileInputs = ({ profile }) => {
  const [userName, setUserName] = useState("");
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const { userData } = useSelector(getSettingState);
  const { mutate } = useSWRConfig();

  const { trigger, isMutating } = useSWRMutation(
    [`${process.env.REACT_APP_API}/auth/profile/update/`, tokenStorage],
    fetcherPatch,
    {
      onSuccess: () => {
        dispatch(setSnackbarMode(true));
        dispatch(setSnackbarTitle("Your information has been updated"));
        mutate(`${process.env.REACT_APP_API}/auth/profile/${userData}/`);
        navigate("/profile");
      },
      onError: (e) => {
        if (e.request.statusText === "Unauthorized") {
          navigate("/profile");
        }
      },
    }
  );

  // set name after load
  useEffect(() => {
    if (profile) {
      setUserName(profile.username);
      setName(profile.nickname);
      setBio(profile.bio);
    }
  }, [profile]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    if (userName.length < 3 || userName.length > 20) {
      dispatch(setSnackbarMode(true));
      dispatch(setSnackbarTitle("Username between 3 and 15 characters"));
      return;
    }
    if (name.length < 3 || name.length > 20) {
      dispatch(setSnackbarMode(true));
      dispatch(setSnackbarTitle("name between 3 and 15 characters"));
      return;
    }
    userName && formData.append("username", userName);
    name && formData.append("nickname", name);
    formData.append("bio", bio);
    try {
      await trigger(formData);
    } catch (e) {}
  };

  return (
    <FormControl
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      component={"form"}
      onSubmit={handleSubmit}
      fullWidth
    >
      <Box sx={{ mb: "26px", width: "100%" }}>
        <CustomInput
          loading={!profile}
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          label=' UserName'
          startIcon='@'
          helperText='Your username makes your profile address in Azad'
          minLength={3}
          maxLength={30}
          req
        />
      </Box>

      <Box sx={{ mb: "26px", width: "100%" }}>
        <CustomInput
          loading={!profile}
          value={name}
          onChange={(e) => setName(e.target.value)}
          label='Name'
          helperText='Other users will know you by your name'
          minLength={3}
          maxLength={30}
          req
        />
      </Box>

      <Box sx={{ width: "100%" }}>
        <CustomInput
          loading={!profile}
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          label='bio'
          multiline
        />
      </Box>
      <Box sx={{ marginTop: "45px", marginBottom: "55px", width: "100%" }}>
        <CustomButton
          submit
          disabled={isMutating}
          title=' Save changes'
          fSize='20px'
          width='100%'
          height='48px'
          bShadow='4px'
          bgColor='primary.main'
        />
      </Box>
    </FormControl>
  );
};

export default EditProfileInputs;
